require('./_result-item');
require('./_preview-modal');
require('./_listen-modal');

$(() => {
  let addToListIds = {};
  let dataArr = [];

  $('.select-template').select2({
    placeholder: __('Select List'),
    minimumResultsForSearch: Infinity
  });

  /* ADD TO LIST */
  $('#addToListForm').submit((e) => {
    e.preventDefault();
  });

  $('#submit-view').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles: addToListIds,
      dataArr
    }, (data) => {
      clearErrors(form);
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();

        if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        addToListIds = {};
        /* redirect to url from response */
        window.location.href = `${redirectToListUrl}?id=${data.idList}`;
      }
    });
  });

  $('#submit-continue').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles: addToListIds,
      dataArr
    }, (data) => {
      clearErrors(form);
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();

        if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        /* update select with new list */
        if (data.newList == 1) {
          const listOption = $('<option>').attr('value', data.idList).html(data.title);

          $('#addToListModal').find('select[name="list-id"]').append(listOption);
        }

        addToListIds = {};
        $('#addToListModal').modal('hide');

        toastr.success('Successfully added to list');
      }
    });
  });

  $('#addToListModal').on('hide.bs.modal', (e) => {
    addToListIds = {};
  });

  $('#addToListModal').on('show.bs.modal', (e) => {
    $('#addToListAlert').hide();

    $('.select-template').select2('val', '');
    $('#addToListModal input[name="list-name"]').val('');
    clearErrors($('#addToListForm'));
  });
  /* END ADD TO LIST */

  $('#addToListModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);

    $('#atl-title').html(`"${btn.data('title')}"`);
    $('#atl-subtitle').html(btn.data('subtitle'));

    addToListIds[btn.data('id-item')] = btn.data('title');
  });

  // $('#reportAllModal').on('show.bs.modal', (e) => {
  //   let titles = '';
  //   let titlesNumber = 0;
  //
  //   $('input.report-checkbox').each(function () {
  //     if ($(this).is(':checked')) {
  //       titlesNumber++;
  //       titles += `<h4 class="text-center">${$(this).data('title')}</h4>`;
  //     }
  //   });
  //
  //   if (titlesNumber == 0) {
  //     $('#report-titles-body').hide();
  //     $('#report-no-titles-body').show();
  //   } else {
  //     $('#titles-number').html(titlesNumber);
  //     $('#report-titles-list').html(titles);
  //
  //     $('#report-titles-body').show();
  //     $('#report-no-titles-body').hide();
  //   }
  // });

  function clearErrors(form) {
    form.find('.help-block').remove();
    form.find('.form-group').removeClass('has-error');
  }
});
